import {
    Box,
    Card,
    Container,
    Grid,
    Stack,
    Text
} from "@mantine/core";
import {
    FormPageLayout,
    SimplePageContentWrapper
} from "@flexinet/ui-components";
import {DeleteAccountForm} from "../forms/DeleteAccountForm.tsx";
import {AiOutlineWarning} from "react-icons/ai";
import {DeleteAccountPageNavigation} from "../navigation/DeleteAccountPageNavigation";


export const DeleteAccountPage = () => {
    return (
        <FormPageLayout
            title="Delete Account"
            pageNavigation={<DeleteAccountPageNavigation/>}
        >
            <SimplePageContentWrapper>
                <Container>
                    <Stack gap={'xl'}>
                        <Card shadow={'sm'}>
                            <Grid>
                                <Grid.Col span={1}>
                                    <AiOutlineWarning size={'3em'} color={'orange'}/>
                                </Grid.Col>
                                <Grid.Col span={11}>
                                    <Box>
                                        <Text>I understand that I may delete my account at any time. I understand that I
                                            may
                                            lose
                                            access to my account data if I delete it.</Text>
                                    </Box>
                                </Grid.Col>
                            </Grid>
                        </Card>

                        <Box my={'xl'}>
                            <DeleteAccountForm/>
                        </Box>
                    </Stack>
                </Container>
            </SimplePageContentWrapper>
        </FormPageLayout>
    );
};
